import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import {
  FILE_EXPORT_TYPES,
  HTTP_ENDPOINTS,
} from "../../../../../../consts/api";
import { SALES_REPORT_EXPORT_NAMES } from "../../../../../../api/mutations/useSalesReportExportMutation";
import { removeNullishFromShape } from "../../../../../../utilities/general";
import { composeDownloadDataUrl } from "../../../../../../utilities/api";
import { uiNotification } from "../../../../../../services/UINotificationService";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";

export const useDownloadExcel = (requestParams) => {
  const { tCommon } = useAppTranslation.Common();

  const res = useMutation(
    () =>
      http.post(
        HTTP_ENDPOINTS.postSalesReportExport(),
        removeNullishFromShape({
          export_type: FILE_EXPORT_TYPES.xls,
          export_name: SALES_REPORT_EXPORT_NAMES.membershipSavingsReport,
          ...requestParams,
        }),
      ),
    {
      onSuccess: (res) =>
        window.open(composeDownloadDataUrl(res.data.data.file), "_blank"),
      onError: () => {
        uiNotification.error(tCommon("error.exportXlsReports"));
      },
    },
  );
  return res;
};
